/** How the capture modal is configured for one kind of photo. */
export interface PhotoCaptureSettings {
  /** Title on the action picker and the capture modal. */
  title: string;
  /** Crop aspect ratio, width / height. */
  aspectRatio: number;
  /** IP camera category to offer, or undefined for every camera. */
  cameraCategory?: string;
  disableFaceDetection: boolean;
}

const IDENTITY: PhotoCaptureSettings = {
  title: 'Foto de Identificação',
  aspectRatio: 4 / 5,
  cameraCategory: 'captura_facial',
  disableFaceDetection: false,
};

/** Landscape, no face to find — the shape every non-identity photo here has. */
const document = (title: string, cameraCategory?: string): PhotoCaptureSettings => ({
  title,
  aspectRatio: 3 / 2,
  cameraCategory,
  disableFaceDetection: true,
});

const BY_TYPE: Record<string, PhotoCaptureSettings> = {
  document_front: document('Documento — Frente', 'documento'),
  document_back: document('Documento — Verso', 'documento'),
  other: document('Outro Documento', 'documento'),
  // A vehicle gets EVERY camera, not a 'veiculo' category: no camera is tagged that way — the
  // categories in use are captura_facial, visitante and documento — so filtering on it left
  // the picker empty and the operator looking at "Sem câmera" with no way forward.
  vehicle: document('Foto do Veículo'),
};

/**
 * The capture setup for a `photo_type`.
 *
 * An absent type means the identity photo, which is what the backend defaults to when the
 * field is missing from the upload.
 */
export function photoCaptureSettings(photoType?: string): PhotoCaptureSettings {
  return (photoType && BY_TYPE[photoType]) || IDENTITY;
}
